/* -------------- Operation based interfaces -------------- */

// LIST
export interface DocCategoryListItem {
	categoryId: string;
	categoryNo: number;
	hasDocuments: boolean;
	categoryName: string;
	url: string;
	creationDate: string;
}

export interface DocCategoryListApiResponse {
	result: {
		items: DocCategoryListItem[];
	};
	error: string | null;
    isSuccessful: boolean;
}

// GET
export interface DocCategoryDetail {
	categoryId: string;
	categoryNo?: number;
	categoryName: string;
}

export interface DocCategoryGetApiResponse {
	result: {
		categoryId: string;
		categoryNo?: number;
		categoryName: string;
	}
	error: string | null;
	isSuccessful: boolean;
}

// ADD/UPDATE
export interface DocCategoryFormData {
	categoryId?: string;
	categoryName: string;
	categoryNo?: number;
}

export const defaultDocCategoryData: DocCategoryFormData = {
	categoryId: "",
	categoryName: "",
	categoryNo: undefined,
};

// Page States
export type OperationStatus =
	| { type: "idle" }
	| { type: "loading"; operation: "add" | "fetch" | "update" | "delete" }
	| { type: "error"; operation: string; message: string };


